import { Box, useTheme } from "@mui/material";
import BaseCard from "../../../theme/cards/BaseCard";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import { getWebshopLogo, marketPlaceAppIconsMap, normalizeMarketPlaceName } from "../../../../utils/logomapper";
import TopRight from "../../../theme/positionals/TopRight";
import CardLabel from "../../../theme/label/CardLabel";
import { useTranslation } from "react-i18next";
import { GridCheckIcon, GridCloseIcon } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { useState } from "react";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import { useSelector } from "react-redux";

export const RelationWebshopIntegrationCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    let name = props.webshop_type;
    if(props.webshop_type === "etailize") {
        name = props.credentials || props.webshop_type;
    }
    const webshopLogo = getWebshopLogo(props.webshop_type,{theme,colors},name);
    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick ? props.onClick : null}>
            <Box>
                <Box
                >
                    {props.skeleton ?
                        <ShDoubleTextSkeleton/> 
                        :
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:1,  
                            }}
                        >
                            {webshopLogo ?? null}
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:"column",
                                }}
                            >
                                <Text bold >{props.description}</Text>
                                {isFulfilment &&
                                    <Text>{props.relation?.name}</Text>
                                }
                            </Box>
                        </Box>
                    }
                </Box>
                <TopRight>
                    <CardLabel variant={props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey"}>
                    {t(props.state)}    
                    </CardLabel>
                </TopRight>
                <Box
                    sx={{
                        mt:2,
                    }}
                > 
                    {props.skeleton ? 
                        <ShTextSkeleton /> 
                    : 
                        <Text light>{props.warehouse?.name ?? t("no_warehouses")}</Text>
                    }
                </Box>
            </Box>
        </BaseCard>
    )
}

export const RelationWebshopFromIntegratorCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const normName = normalizeMarketPlaceName(props.description).toLowerCase();
    const match = marketPlaceAppIconsMap.find(icon => normName.includes(icon.name));

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;
    
    const handlePopoverClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick ? props.onClick : null}>
            <Box>
                <Box
                >
                    {props.skeleton ?
                        <ShDoubleTextSkeleton/> 
                        :
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:1,  
                            }}
                        >
                            {match?.Icon &&
                                <Box
                                    sx={{
                                        borderRadius:4,
                                        height:32,
                                        overflow:'hidden',
                                        background:theme.palette.mode === "dark" ? colors.txt["primary"] : null,
                                    }}
                                >
                                    <match.Icon width={32} height={32} />
                                </Box>
                            }
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:"column",
                                }}
                            >
                                <Text bold >{props.description}</Text>
                                <Text >{props.integrator?.name}</Text>
                            </Box>
                        </Box>
                    }
                </Box>
                <TopRight>
                    <CardLabel 
                        onClick={handlePopoverClick}
                        position="child-tr"
                        icon
                        hasright
                        variant={props.syncOrders  ? "green" : "red"}
                    >
                        {
                            props.syncOrders  ?
                            <GridCheckIcon fontSize="small" sx={{color:colors.green[400]}}/> 
                            : 
                            <GridCloseIcon fontSize="small" sx={{color:colors.red[400]}}/>
                        }
                    </CardLabel>
                    <CardLabel 
                        position="child-tr"
                        hasleft
                        variant={props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey"}
                    >
                        {t(props.state)}    
                    </CardLabel>
                </TopRight>

                        
                <Box
                    sx={{
                        mt:2,
                    }}
                > 
                    {props.skeleton ? 
                        <ShTextSkeleton /> 
                    : 
                        <Text light>{props.warehouse?.name ?? t("no_warehouses")}</Text>
                    }
                </Box>

                <IMDistributesOrders 
                    syncOrders={props.syncOrders}
                    id={popoverId}
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    stopPropagation={true}
                />
            </Box>
        </BaseCard>
    )
}


const IMDistributesOrders = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        
        <PopoverModal
            {...props}
            triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    padding:3,
                    paddingBottom: isStandAlone ? 4 : 3,
                    borderRadius:"16px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderTopLeftRadius:"12px",
                        borderTopRightRadius:"12px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                {props.syncOrders ?
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            flexDirection:"column",
                            gap:1,
                        }}
                    >
                        <Box
                            sx={{
                                width:40,
                                height:40,
                                borderRadius:3,
                                background:colors.green[100],
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >
                            <GridCheckIcon  sx={{color:colors.green[400]}}/> 
                        </Box>
                        <Text semibold>{t('syncOrders')}</Text>
                    </Box>
                :
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            flexDirection:"column",
                            gap:1,
                        }}
                    >
                        <Box
                            sx={{
                                width:40,
                                height:40,
                                borderRadius:3,
                                background:colors.red[100],
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center"
                            }}
                        >
                            <GridCloseIcon  sx={{color:colors.red[400]}}/> 
                        </Box>
                        <Text semibold>{t('syncOrders')}</Text>
                    </Box>
                }

                
            </Box>

        </PopoverModal>
    );
}


export const WebshopWebshopIntegrationCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick ? props.onClick : null}>
            <Box>
                <Box
                >
                    {props.skeleton ?
                        <ShDoubleTextSkeleton/> 
                        :
                        <Box
                            sx={{
                                display:"flex",
                                flexDirection:"column",
                            }}
                        >
                            <Text bold >{props.description}</Text>
                            {isFulfilment &&
                                <Text>{props.relation?.name}</Text>
                            }
                        </Box>
                    }
                </Box>
                <TopRight>
                    <CardLabel variant={props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey"}>
                    {t(props.state)}    
                    </CardLabel>
                </TopRight>
                <Box
                    sx={{
                        mt:2,
                    }}
                > 
                    {props.skeleton ? 
                        <ShTextSkeleton /> 
                    : 
                        <Text light>{props.warehouse?.name ?? t("no_warehouses")}</Text>
                    }
                </Box>
            </Box>
        </BaseCard>
    )
}
